const specs = {
  width: 620,
  title: {
    update: 'pages.operations.modal.update.single.title',
    create: 'pages.operations.modal.create.single.title'
  },
  okText: {
    update: 'pages.operations.modal.update.single.okText',
    create: 'pages.operations.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.operations.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.operations.fields.name.title',
        required: 'pages.operations.fields.name.requiredMessage',
        placeholder: 'pages.operations.fields.name.placeholder'
      },
      empty: 'common.unknown.male'
    }
  }
}

export default specs
